"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Desktop = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _coreDecorators = require("core-decorators");

var _classnames = _interopRequireDefault(require("classnames"));

var _AccentButton = _interopRequireDefault(require("../../Button/AccentButton"));

var _Expandable = _interopRequireDefault(require("../../Expandable"));

var _styles = _interopRequireDefault(require("./styles"));

var _Group = require("./Group");

var _class, _temp;

var getGroupSelectedItems = function getGroupSelectedItems(groupIndex, selectedItemsGroupArray) {
  var groupItem = selectedItemsGroupArray.filter(function (item) {
    return item.groupIndex === groupIndex;
  });
  groupItem = groupItem.length > 0 ? groupItem[0] : {};
  return groupItem.selectedItemsArray || [];
};

var Desktop = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Desktop, _React$Component);

  function Desktop() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Desktop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Desktop)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      expanded: false
    });
    return _this;
  }

  (0, _createClass2.default)(Desktop, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          groups = _this$props.groups,
          selectedKeysSet = _this$props.selectedKeysSet,
          controlledSelectedItems = _this$props.controlledSelectedItems,
          selectedItemsGroupArray = _this$props.selectedItemsGroupArray,
          onSelectKey = _this$props.onSelectKey,
          onRemoveKey = _this$props.onRemoveKey,
          theme = _this$props.theme,
          className = _this$props.className,
          withSearch = _this$props.withSearch,
          onSearch = _this$props.onSearch,
          groupClassName = _this$props.groupClassName;
      var expanded = this.state.expanded;
      var showExpandButton = groups.some(function (g) {
        return !g.primary;
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(_styles.default.root, className)
      }, renderGroups(groups, expanded, selectedKeysSet, onSelectKey, onRemoveKey, withSearch, onSearch, theme, groupClassName, controlledSelectedItems, selectedItemsGroupArray), showExpandButton && renderExpandButton(expanded, this.expandClickHandler));
    }
  }, {
    key: "expandClickHandler",
    value: function expandClickHandler() {
      this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    }
  }]);
  return Desktop;
}(_react.default.Component), _temp), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "expandClickHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "expandClickHandler"), _class.prototype)), _class);
exports.Desktop = Desktop;
Desktop.propTypes = {
  theme: _propTypes.default.any.isRequired,
  className: _propTypes.default.string.isRequired,
  groups: _propTypes.default.array.isRequired,
  selectedKeysSet: _propTypes.default.instanceOf(Set).isRequired,
  onSelectKey: _propTypes.default.func.isRequired,
  onRemoveKey: _propTypes.default.func.isRequired,
  onSearch: _propTypes.default.func
};
Desktop.defaultProps = {
  onSearch: function onSearch() {}
};

function renderGroups(groups, expanded, selectedKeysSet, onSelectKey, onRemoveKey, withSearch, onSearch, theme, groupClassName, controlledSelectedItems, selectedItemsGroupArray) {
  return _react.default.createElement("div", {
    className: _styles.default.groups(theme)
  }, groups.map(function (g, index) {
    return _react.default.createElement(_Expandable.default, {
      key: g.key,
      visible: isGroupVisible(g, expanded, selectedKeysSet, index, controlledSelectedItems, selectedItemsGroupArray)
    }, _react.default.createElement(_Group.Group, {
      index: index,
      group: g,
      selectedKeysSet: selectedKeysSet,
      controlledSelectedItems: controlledSelectedItems,
      selectedItemsGroupArray: selectedItemsGroupArray,
      groupSelectedItems: controlledSelectedItems ? getGroupSelectedItems(index, selectedItemsGroupArray) : [],
      onSelectKey: onSelectKey,
      onRemoveKey: onRemoveKey,
      withSearch: withSearch,
      theme: theme,
      onSearch: onSearch,
      groupClassName: groupClassName
    }));
  }));
}

function renderExpandButton(expanded, clickHandler) {
  return _react.default.createElement(_AccentButton.default, {
    text: expanded ? 'Less' : 'More',
    icon: {
      type: 'angle-down',
      rotate: expanded ? 180 : 0,
      style: {
        marginLeft: '6px',
        width: '14px',
        height: '14px'
      }
    },
    iconPosition: "right",
    onClick: clickHandler,
    style: {
      fontSize: '16px'
    }
  });
}

function isGroupVisible(group, expanded, selectedKeysSet, groupIndex, controlledSelectedItems, selectedItemsGroupArray) {
  if (group.items.length === 0 && !controlledSelectedItems) {
    return false;
  }

  var groupHasSelectedItems = false;

  if (controlledSelectedItems) {
    var groupSelectedItemsArray = getGroupSelectedItems(groupIndex, selectedItemsGroupArray);

    if (groupSelectedItemsArray.length > 0) {
      groupHasSelectedItems = true;
    }
  }

  return expanded || group.primary || group.items.some(function (i) {
    return selectedKeysSet.has(i.key);
  }) || groupHasSelectedItems;
}